interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {name: 'UnityLoader', src: '/assets/videocall/legacy/Build/Build.loader.js'},
  {name: 'UnityHooks', src: '/assets/videocall/legacy/UnityHooks.js'},
];
